export default __webpack_public_path__ + "static/media/claim.dee7fc25.png";